module.exports = __webpack_public_path__ + "media/images/icons/flags/UG-f170ae5f652c0cb6e9fe4bd5c5792b29.svg";